import React, {Component} from "react";
import {withTranslation} from "react-i18next";
import styles from "../../../../../../ricercaSegnalazioni/ricercaSegnalazioni.module.css";
import RadioButton from "../../../../../../../components/radiobutton/RadioButton";
import Calendar from "../../../../../../../components/calendar/Calendar";
import Utils from "../../../../../../../utils/Utils";

class StatoVaccinale extends Component {

    state = {
        statoVaccinale: {

            precedenteVaccinazioneMorbillo: "",
            numeroDosiMorbillo: "",
            dataUtlimaDoseMorbillo: "",
            vaccinzaioneVerificataMorbillo: "",


            precedenteVaccinazioneRosolia: "",
            dataUtlimaDoseRosolia: "",
            vaccinzaioneVerificataRosolia: "",
            corretto: []
        },
        statoVaccinaleMorbillo: "",
        statoVaccinaleRosolia: "",
        malattie: {
            rosolia: Utils.mapMalattieDescrizione("ROSOLIA"),
            morbillo: Utils.mapMalattieDescrizione("MORBILLO")
        }
    }

    constructor(props) {
        super(props);
        this.createStatoVaccinale = this.createStatoVaccinale.bind(this)
        this.riceviValore = this.riceviValore.bind(this)
        this.controlloCorrettezza = this.controlloCorrettezza.bind(this)
        this.validate = this.validate.bind(this);

    }

    componentDidMount() {
        let statoVaccinale = this.state.statoVaccinale
        if (this.props.segnalazioneCopia && this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.statoVaccinale) {
            let statoVaccinaleCopia = this.props.segnalazioneCopia.schedaSpeciale.statoVaccinale
            for (let key in statoVaccinale) {
                if (statoVaccinale.hasOwnProperty(key) === statoVaccinaleCopia.hasOwnProperty(key)) {
                    statoVaccinale[key] = statoVaccinaleCopia[key]
                } else {
                    statoVaccinale[key] = ""
                }
            }
            this.setState({statoVaccinale: statoVaccinale})
        } else if (this.props.segnalazioneCopia && this.props.segnalazioneCopia.datiSpecifici && this.props.segnalazioneCopia.datiSpecifici.vaccinazioni) {
            if (this.props.segnalazioneCopia.malattia === this.state.malattie.rosolia) {
                statoVaccinale.precedenteVaccinazioneRosolia = this.props.segnalazioneCopia.datiSpecifici.vaccinazioni.precedentiVaccinazioni
                if (this.props.segnalazioneCopia.datiSpecifici.vaccinazioni.precedentiVaccinazioni === 1 && this.props.segnalazioneCopia.datiSpecifici.vaccinazioni.tableVaccinazioni) {

                    let arrayDate = JSON.parse(JSON.stringify(this.props.segnalazioneCopia.datiSpecifici.vaccinazioni.tableVaccinazioni))

                    arrayDate.sort(this.confrontaDate);

                    statoVaccinale.dataUtlimaDoseRosolia = arrayDate[arrayDate.length - 1].dataVaccinazioni
                } else {
                    statoVaccinale.dataUtlimaDoseRosolia = ""
                }

            } else if (this.props.segnalazioneCopia.malattia === this.state.malattie.morbillo) {
                statoVaccinale.precedenteVaccinazioneMorbillo = this.props.segnalazioneCopia.datiSpecifici.vaccinazioni.precedentiVaccinazioni

                statoVaccinale.precedenteVaccinazioneMorbillo = this.props.segnalazioneCopia.datiSpecifici.vaccinazioni.precedentiVaccinazioni
                if (this.props.segnalazioneCopia.datiSpecifici.vaccinazioni.precedentiVaccinazioni == 1 && this.props.segnalazioneCopia.datiSpecifici.vaccinazioni.tableVaccinazioni) {

                    let arrayDate = JSON.parse(JSON.stringify(this.props.segnalazioneCopia.datiSpecifici.vaccinazioni.tableVaccinazioni))

                    arrayDate.sort(this.confrontaDate);

                    statoVaccinale.dataUtlimaDoseMorbillo = arrayDate[arrayDate.length - 1].dataVaccinazioni

                } else {
                    statoVaccinale.dataUtlimaDoseMorbillo = ""
                }

            }
        }
        this.createStatoVaccinale("Morbillo")
        this.createStatoVaccinale("Rosolia")
        this.controlloCorrettezza()
        let oggettoBE = this.createObjectBE()
        let corretto = statoVaccinale.corretto
        this.props.createOggettoBeAndcontrolloCorrettezza("statoVaccinale", oggettoBE, corretto)
    }

    confrontaDate(date1, date2) {
        if (date1.dataVaccinazioni < date2.dataVaccinazioni) {
            return -1;
        } else {
            if (date1.dataVaccinazioni > date2.dataVaccinazioni) {
                return 1;
            } else {
                return 0;
            }
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
    }

    validate() {

        if (this.state.statoVaccinale.dataUtlimaDoseRosolia && Utils.validateDate(this.state.statoVaccinale.dataUtlimaDoseRosolia, "Messages.DataUltimaDose", "Messages.DataUltimaDoseOdierna")) {
            return Utils.validateDate(this.state.statoVaccinale.dataUtlimaDoseRosolia, "Messages.DataUltimaDose", "Messages.DataUltimaDoseOdierna")
        }
        if (this.state.statoVaccinale.dataUtlimaDoseMorbillo && Utils.validateDate(this.state.statoVaccinale.dataUtlimaDoseMorbillo, "Messages.DataUltimaDose", "Messages.DataUltimaDoseOdierna")) {
            return Utils.validateDate(this.state.statoVaccinale.dataUtlimaDoseMorbillo, "Messages.DataUltimaDose", "Messages.DataUltimaDoseOdierna")
        }

        if (this.state.statoVaccinale.precedenteVaccinazioneMorbillo !== "1") {
            if (this.state.statoVaccinale.numeroDosiMorbillo) return "Messages.ERR_01_02_0G_BE"
            else if (this.state.statoVaccinale.dataUtlimaDoseMorbillo) return "Messages.ERR_01_02_0G_BF"
            else if (this.state.statoVaccinale.vaccinzaioneVerificataMorbillo) return "Messages.ERR_01_02_0G_BG"
        } else if (this.state.statoVaccinale.precedenteVaccinazioneRosolia !== "1") {
            if (this.state.statoVaccinale.dataUtlimaDoseRosolia) return "Messages.ERR_01_02_0G_BH"
            else if (this.state.statoVaccinale.vaccinzaioneVerificataRosolia) return "Messages.ERR_01_02_0G_BI"
        }

        return ""

    }

    riceviValore(field, event) {
        let statoVaccinale = this.state.statoVaccinale
        statoVaccinale[field] = event.target.value

        if (statoVaccinale.precedenteVaccinazioneMorbillo !== "1") {
            statoVaccinale.numeroDosiMorbillo = ""
            statoVaccinale.dataUtlimaDoseMorbillo = ""
            statoVaccinale.vaccinzaioneVerificataMorbillo = ""
        }

        if (statoVaccinale.precedenteVaccinazioneRosolia !== "1") {
            statoVaccinale.dataUtlimaDoseRosolia = ""
            statoVaccinale.vaccinzaioneVerificataRosolia = ""
        }

        this.setState({statoVaccinale: statoVaccinale})
        this.createStatoVaccinale("Morbillo")
        this.createStatoVaccinale("Rosolia")
        this.controlloCorrettezza()
        let oggettoBE = this.createObjectBE()
        let corretto = statoVaccinale.corretto
        this.props.createOggettoBeAndcontrolloCorrettezza("statoVaccinale", oggettoBE, corretto, this.validate())
    }


    controlloCorrettezza() {
        let statoVaccinale = this.state.statoVaccinale
        statoVaccinale.corretto = []

        if (statoVaccinale.precedenteVaccinazioneRosolia === "1") {
            if (!statoVaccinale.dataUtlimaDoseRosolia || (statoVaccinale.dataUtlimaDoseRosolia &&
                Utils.isDateInValid(Utils.transformDateForBackend(statoVaccinale.dataUtlimaDoseRosolia), "-"))) statoVaccinale.corretto[0] = "Campo \"Se si, data ultima dose\" mancante";
            if (!statoVaccinale.vaccinzaioneVerificataRosolia) statoVaccinale.corretto[1] = "Campo \"Vaccinazione contro la rosolia verificata da certificato vaccinale\" mancante";
        }

        if (statoVaccinale.precedenteVaccinazioneMorbillo === "1") {
            if (!statoVaccinale.vaccinzaioneVerificataMorbillo) statoVaccinale.corretto[2] = "Campo \"Vaccinazione contro il morbillo verificata da certificato vaccinale\" mancante";
            if (!statoVaccinale.dataUtlimaDoseMorbillo || (statoVaccinale.dataUtlimaDoseMorbillo &&
                Utils.isDateInValid(Utils.transformDateForBackend(statoVaccinale.dataUtlimaDoseMorbillo), "-")))  statoVaccinale.corretto[3] = "Campo \"Se si, data ultima dose\" mancante o errato";
            if (!statoVaccinale.numeroDosiMorbillo) statoVaccinale.corretto[4] = "Campo \"Se si, numero di dosi\" mancante";
        }

        return this.setState({statoVaccinale: statoVaccinale})
    }

    createObjectBE() {
        let oggettoBE = JSON.parse(JSON.stringify(this.state.statoVaccinale))
        Utils.removeFieldFromObject(oggettoBE, "corretto")
        let res = Utils.removeEmptyValueFromObject(oggettoBE)
        return res
    }

    createStatoVaccinale(malattiaVaccinazione) {
        const {t} = this.props
        let stato = this.state.statoVaccinale
        let statoVaccinale = (
            <div style={{marginTop: "1rem"}} className={"container"}>
                <div className={"row"}>
                    <div className={"col-lg-6"}>
                        <p style={{color: "black", marginTop: "0.5rem", fontWeight: "bold"}}>
                            {t("SchedaSpecialeMorbillo.vaccinazione" + malattiaVaccinazione)}
                        </p>
                    </div>
                    <div className={"col-lg-6"}>
                        <div className={"row"}>
                            <div className={"col-lg-2"}>
                                <RadioButton id={"precedenteVaccinazione" + malattiaVaccinazione + "Si"}
                                             name={"precedenteVaccinazione" + malattiaVaccinazione}
                                             label={t("SchedaSpecialeMorbillo.si")}
                                             style={{color: "black", fontSize: "16px"}}
                                             newRadio={true}
                                             onClick={this.riceviValore}
                                             smallLabel={true} value={"1"}
                                             checked={
                                                 malattiaVaccinazione === "Morbillo" ? stato.precedenteVaccinazioneMorbillo === "1" :
                                                     stato.precedenteVaccinazioneRosolia === "1"}>
                                </RadioButton>
                            </div>
                            <div className={"col-lg-2"}>
                                <RadioButton id={"precedenteVaccinazione" + malattiaVaccinazione + "No"}
                                             name={"precedenteVaccinazione" + malattiaVaccinazione}
                                             label={t("SchedaSpecialeMorbillo.no")}
                                             style={{color: "black", fontSize: "16px"}}
                                             newRadio={true}
                                             onClick={this.riceviValore}
                                             smallLabel={true} value={"2"}
                                             checked={
                                                 malattiaVaccinazione === "Morbillo" ? stato.precedenteVaccinazioneMorbillo === "2" :
                                                     stato.precedenteVaccinazioneRosolia === "2"}>
                                </RadioButton>

                            </div>
                            <div className={"col-lg-3"}>
                                <RadioButton id={"precedenteVaccinazione" + malattiaVaccinazione + "NonRicordo"}
                                             name={"precedenteVaccinazione" + malattiaVaccinazione}
                                             label={t("SchedaSpecialeMorbillo.nonRicordo")}
                                             style={{color: "black", fontSize: "16px"}}
                                             newRadio={true}
                                             onClick={this.riceviValore}
                                             smallLabel={true} value={"3"}
                                             checked={
                                                 malattiaVaccinazione === "Morbillo" ? stato.precedenteVaccinazioneMorbillo === "3" :
                                                     stato.precedenteVaccinazioneRosolia === "3"}>
                                </RadioButton>
                            </div>
                        </div>
                    </div>
                </div>

                <div className={"row"} style={{display: malattiaVaccinazione === "Rosolia" ? "none" : ""}}>
                    <div className={"col-lg-6"}>
                        {malattiaVaccinazione === "Morbillo" ?
                            <p style={{color: "black", marginTop: "0.5rem", fontWeight: "normal"}}>
                                {t("SchedaSpecialeMorbillo.seSi")}
                                <span style={{
                                    color: "black",
                                    fontWeight: "bold"
                                }}>{t("SchedaSpecialeMorbillo.numeroDosi")}</span>
                                {this.state.statoVaccinale.precedenteVaccinazioneMorbillo === "1" ?
                                    <span className={styles.mandatoryColor}>*</span> : ""}
                            </p> :
                            <p style={{color: "black", marginTop: "0.5rem", fontWeight: "bold"}}>
                                {t("SchedaSpecialeMorbillo.sesi")}
                                <p style={{
                                    color: "black",
                                    marginTop: "0.5rem",
                                    fontWeight: "bold"
                                }}>{t("SchedaSpecialeMorbillo.numeroDosi")}</p>
                                {this.state.statoVaccinale.precedenteVaccinazioneRosolia === "1" ?
                                    <span className={styles.mandatoryColor}>*</span> : ""}
                            </p>
                        }
                    </div>
                    <div className={"col-lg-6"}>
                        <div className={"row"}>
                            <div className={"col-lg-2"}>
                                <RadioButton id={"numeroDosi" + malattiaVaccinazione + "1"}
                                             name={"numeroDosi" + malattiaVaccinazione}
                                             label={"1"}
                                             disabled={(this.state.statoVaccinale.precedenteVaccinazioneMorbillo !== "1")}
                                             style={{color: "black", fontSize: "16px"}}
                                             newRadio={true}
                                             onClick={this.riceviValore}
                                             smallLabel={true} value={"1"}
                                             checked={
                                                 malattiaVaccinazione === "Morbillo" ? stato.numeroDosiMorbillo === "1" : ""}>
                                </RadioButton>
                            </div>
                            <div className={"col-lg-2"}>
                                <RadioButton id={"numeroDosi" + malattiaVaccinazione + "2"}
                                             name={"numeroDosi" + malattiaVaccinazione}
                                             label={"2"}
                                             style={{color: "black", fontSize: "16px"}}
                                             newRadio={true}
                                             disabled={this.state.statoVaccinale.precedenteVaccinazioneMorbillo !== "1"}
                                             onClick={this.riceviValore}
                                             smallLabel={true} value={"2"}
                                             checked={
                                                 malattiaVaccinazione === "Morbillo" ? stato.numeroDosiMorbillo === "2" : ""}>
                                </RadioButton>

                            </div>
                            <div className={"col-lg-3"}>
                                <RadioButton id={"numeroDosi" + malattiaVaccinazione + "NonRicordo"}
                                             name={"numeroDosi" + malattiaVaccinazione}
                                             label={t("SchedaSpecialeMorbillo.nonRicordo")}
                                             style={{color: "black", fontSize: "16px"}}
                                             newRadio={true}
                                             disabled={this.state.statoVaccinale.precedenteVaccinazioneMorbillo !== "1"}
                                             onClick={this.riceviValore}
                                             smallLabel={true} value={"3"}
                                             checked={
                                                 malattiaVaccinazione === "Morbillo" ? stato.numeroDosiMorbillo === "3" : ""}>
                                </RadioButton>
                            </div>
                        </div>
                    </div>
                </div>

                <div className={"row"}>
                    <div className={"col-lg-6"}>
                        {malattiaVaccinazione === "Morbillo" ?
                            <p style={{color: "black", marginTop: "0.5rem", fontWeight: "normal"}}>
                                {t("SchedaSpecialeMorbillo.seSi")}
                                <span style={{color: "black", marginTop: "0.5rem", fontWeight: "bold"}}>
                                    {t("SchedaSpecialeMorbillo.dataUltimaDose")}
                                </span>
                                {this.state.statoVaccinale.precedenteVaccinazioneMorbillo === "1" ?
                                    <span className={styles.mandatoryColor}>*</span> : ""}
                            </p> :
                            <p style={{color: "black", marginTop: "0.5rem", fontWeight: "bold"}}>
                                <span style={{fontWeight: "normal"}}>{t("SchedaSpecialeMorbillo.seSi")}</span>
                                {t("SchedaSpecialeMorbillo.dataUltimaDose")}
                                {this.state.statoVaccinale.precedenteVaccinazioneRosolia === "1" ?
                                    <span className={styles.mandatoryColor}>*</span> : ""}
                            </p>
                        }
                    </div>
                    <div className={"col-lg-3"}>
                        <Calendar
                            id={"dataUtlimaDose" + malattiaVaccinazione}
                            value={malattiaVaccinazione === "Morbillo" ? this.state.statoVaccinale.dataUtlimaDoseMorbillo :
                                this.state.statoVaccinale.dataUtlimaDoseRosolia}
                            field={"dataUtlimaDose" + malattiaVaccinazione}
                            newCalendar={true}
                            onChange={this.riceviValore}
                            errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>", t("SchedaSpecialeMorbillo.dataUltimaDose"))}
                            error={malattiaVaccinazione === "Morbillo" ? (this.state.statoVaccinale.dataUtlimaDoseMorbillo === "" || this.state.statoVaccinale.dataUtlimaDoseMorbillo == null) ? false :
                                Utils.isDateInValid(Utils.transformDateForBackend(this.state.statoVaccinale.dataUtlimaDoseMorbillo), "-") :
                                (this.state.statoVaccinale.dataUtlimaDoseRosolia === "" || this.state.statoVaccinale.dataUtlimaDoseRosolia == null) ? false :
                                    Utils.isDateInValid(Utils.transformDateForBackend(this.state.statoVaccinale.dataUtlimaDoseRosolia), "-")
                            }
                        >
                        </Calendar>
                    </div>
                </div>

                <div className={"row"}>
                    <div className={"col-lg-6"}>
                        {malattiaVaccinazione === "Morbillo" ?
                            <p style={{color: "black", marginTop: "0.5rem", fontWeight: "bold"}}>
                                {t("SchedaSpecialeMorbillo.vaccinazioneContro" + malattiaVaccinazione)}
                                {this.state.statoVaccinale.precedenteVaccinazioneMorbillo === "1" ?
                                    <span className={styles.mandatoryColor}>*</span> : ""}

                            </p> :
                            <p style={{color: "black", marginTop: "0.5rem", fontWeight: "bold"}}>
                                {t("SchedaSpecialeMorbillo.vaccinazioneContro" + malattiaVaccinazione)}
                                {this.state.statoVaccinale.precedenteVaccinazioneRosolia === "1" ?
                                    <span className={styles.mandatoryColor}>*</span> : ""}
                            </p>
                        }
                    </div>
                    <div className={"col-lg-6"}>
                        <div className={"row"}>
                            <div className={"col-lg-2"}>
                                <RadioButton id={"vaccinzaioneVerificata" + malattiaVaccinazione + "Si"}
                                             name={"vaccinzaioneVerificata" + malattiaVaccinazione}
                                             label={t("SchedaSpecialeMorbillo.si")}
                                             style={{color: "black", fontSize: "16px"}}
                                             newRadio={true}
                                             onClick={this.riceviValore}
                                             smallLabel={true} value={"1"}
                                             checked={
                                                 malattiaVaccinazione === "Morbillo" ? stato.vaccinzaioneVerificataMorbillo === "1" :
                                                     stato.vaccinzaioneVerificataRosolia === "1"}>
                                </RadioButton>
                            </div>
                            <div className={"col-lg-2"}>
                                <RadioButton id={"vaccinzaioneVerificata" + malattiaVaccinazione + "No"}
                                             name={"vaccinzaioneVerificata" + malattiaVaccinazione}
                                             label={t("SchedaSpecialeMorbillo.no")}
                                             style={{color: "black", fontSize: "16px"}}
                                             newRadio={true}
                                             onClick={this.riceviValore}
                                             smallLabel={true} value={"2"}
                                             checked={
                                                 malattiaVaccinazione === "Morbillo" ? stato.vaccinzaioneVerificataMorbillo === "2" :
                                                     stato.vaccinzaioneVerificataRosolia === "2"}>
                                </RadioButton>

                            </div>
                        </div>
                    </div>
                </div>

            </div>
        )
        if (malattiaVaccinazione === "Morbillo") {
            return this.setState({statoVaccinaleMorbillo: statoVaccinale})
        } else if (malattiaVaccinazione === "Rosolia") {
            return this.setState({statoVaccinaleRosolia: statoVaccinale})
        }
    }

    render() {
        const {t} = this.props
        return (
            <div style={{marginTop: "1rem"}}>
                <h6>{t("SchedaSpecialeMorbillo.statoVaccinale")}</h6>
                <hr className={styles.hr}/>
                {this.state.statoVaccinaleMorbillo}
                {this.state.statoVaccinaleRosolia}
            </div>
        );
    }
}

export default withTranslation('common')(StatoVaccinale)
